import * as yup from 'yup';
export const validationSchema = yup.object().shape({
    City: yup.string().required('Выберите город'),
    InsuranceCount: yup.number().max(5, 'Максимальное количество застрахованных — 5'),
    Promocode: yup.string(),
    Price: yup.number(),
    programId: yup.string().required('Обязательное поле'),
});